export const liveAccess = ["radd-3e5602", "barr-42ffcc", "guil-939853"];
export const isHasAccessToLive = (org) => {
  return liveAccess.includes(org);
};
